export default __webpack_public_path__ + "static/person_1-0ccd7cd9e142992bcc8989f2c736515a.png";